<template>
  <div
    :class="$style.filterOptionContainer"
    data-sb-regression="sb-table-filters"
  >
    <sb-button
      v-tooltip.top="$t('sbFilter.filterTooltip')"
      :icon="'pi ' + (isHovering || filterDrawerActive ? 'pi-filter-fill' : 'pi-filter')"
      variation="iconOnly"
      :state="filterDrawerActive ? 'active' : undefined"
      data-sb-automation="filter-bar-open-filter-selection"
      @mouseover="onMouseOver"
      @mouseleave="onMouseOut"
      @click="openFilterDrawer(true)"
    />
    <sb-badge
      v-show="appliedFilterCount > 0"
      size="extra-small"
      data-sb-automation="filter-count"
      :class="$style.filterButtonBadge"
    >
      {{ appliedFilterCount }}
    </sb-badge>
  </div>
  <template>
    <slot
      v-if="$slots['filters-drawer']"
      name="filters-drawer"
    />
    <FiltersDrawer
      v-else
      v-model:active="filterDrawerActive"
      v-model:appliedFilters="appliedFilters"
      :filter-definitions="filterDefinitions"
    />
  </template>
</template>

<script setup>
import { ref, defineModel, defineProps, defineEmits, computed } from 'vue';
import SbBadge from '@src/components/Badge/SbBadge.vue';
import SbButton from '@src/components/Button/SbButton.vue';
import { useI18n } from 'vue-i18n';
import FiltersDrawer from '@src/components/Filter/next/components/SbFiltersDrawer.vue';
import { getValidFilters } from '@src/components/Filter/next/utils';

const { t } = useI18n();
const filterDrawerActive = ref(false);
const isHovering = ref(false);
const onMouseOver = () => {
  isHovering.value = true;
};
const onMouseOut = () => {
  isHovering.value = false;
};
function openFilterDrawer(value) {
  filterDrawerActive.value = value;
}

const props = defineProps({
  filterDefinitions: {
    type: Array,
    default: () => [],
  },
});

const appliedFilters = defineModel('appliedFilters');
const appliedFilterCount = computed(() => {
  return getValidFilters(props.filterDefinitions, appliedFilters.value, t, true).length;
});
</script>

<style module lang="scss">
@use '@src/components/Filter/next/styles/sbTableFilters.module.scss';
</style>
